import { type ProgressSummary } from '@/services/api'
import styles from './StatCards.module.css'

interface Props {
  summary: ProgressSummary
}

export default function StatCards({ summary }: Props) {
  return (
    <div className={styles.grid}>
      <div className={styles.card}>
        <span className={styles.value}>{summary.total}</span>
        <span className={styles.label}>Total Activities</span>
      </div>
      <div className={styles.card}>
        <span className={styles.value}>{summary.this_week}</span>
        <span className={styles.label}>This Week</span>
      </div>
      <div className={`${styles.card} ${styles.highlight}`}>
        <span className={styles.value}>{summary.current_streak}</span>
        <span className={styles.label}>Day Streak</span>
      </div>
      <div className={styles.card}>
        <span className={styles.value}>{summary.longest_streak}</span>
        <span className={styles.label}>Longest Streak</span>
      </div>
    </div>
  )
}
